import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';

import FilterDataTable from 'components/FilterDataTable/FilterDataTable';
import useGetUsersPageData from 'hooks/Users/useGetUsersPageData';
import useGetUsersPageColumns from 'hooks/Users/useGetUsersPageColumns';
import useScreenSize from 'hooks/Screen/useScreenSize';
import { UsersPageDataRow } from 'api/users/types';
import ManageUserModal from 'hooks/Users/Modal/UserModal/ManageUserModal';
import { MLButton } from 'components/Button/Button';
import { useManageUserModalStore } from 'hooks/Users/Modal/UserModal/useMangeUserModalStore';
import DeleteUserModal from 'hooks/Users/Modal/DeleteUserModal/DeleteUserModal';
import UserPageTableExpandable from 'components/Users/UserPageTableExpandable';

const UsersPage: React.FC = () => {
  const [page, setPage] = useState(1);
  const [ordering, setQueryParam] = useState('');
  const [search, setSearch] = useState('');
  const { data: PestUsersData, isLoading, refetch } = useGetUsersPageData('pest_users');
  const {
    data: ClientUsersData,
    isLoading: ClientIsLoading,
    refetch: refetchClientUsers,
  } = useGetUsersPageData('client_users');
  const { onManageUserModalOpen } = useManageUserModalStore();
  const columns = useGetUsersPageColumns('pest_users');
  const clientColumns = useGetUsersPageColumns('client_users');
  const { isNotDesktop } = useScreenSize();

  useEffect(() => {
    refetch();
  }, [page, ordering, search, refetch]);

  return (
    <>
      <div className="page-content">
        <Container fluid>
          {/* <UserHeader /> */}
          <div className="row">
            <div className="card px-0">
              <div className="card-header">
                <div className="d-flex justify-content-between">
                  <div className="d-flex align-items-center">
                    <h4 className="card-title mb-0 flex-grow-1">Company users page</h4>
                  </div>
                  <div className="d-flex">
                    <MLButton
                      isGhost
                      color="success"
                      innerText="+ Create user"
                      fontSize={14}
                      onClick={() => onManageUserModalOpen(false)}
                    />
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-xxl-12">
                    <div className="bg-white">
                      <FilterDataTable<UsersPageDataRow>
                        columns={columns}
                        data={PestUsersData || []}
                        title="My Users"
                        label="Users per page"
                        isMinHeight
                        onChangePage={setPage}
                        onChangeFilterParams={setQueryParam}
                        onChangeSearch={setSearch}
                        isLoading={isLoading}
                        expandableRows={isNotDesktop}
                        expandableRowsComponent={row => <UserPageTableExpandable data={row.data} />}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="card px-0">
              <div className="card-body mt-3">
                <div className="row">
                  <div className="col-xxl-12">
                    <div className="bg-white">
                      <FilterDataTable<UsersPageDataRow>
                        columns={clientColumns}
                        data={ClientUsersData || []}
                        title="Client Users"
                        label="Users per page"
                        isMinHeight
                        onChangePage={setPage}
                        onChangeFilterParams={setQueryParam}
                        onChangeSearch={setSearch}
                        isLoading={ClientIsLoading}
                        expandableRows={isNotDesktop}
                        expandableRowsComponent={row => <UserPageTableExpandable data={row.data} />}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <ManageUserModal refetchUsers={refetch} refetchClientUsers={refetchClientUsers} />
          <DeleteUserModal refetchUsers={refetch} refetchClientUsers={refetchClientUsers} />
        </Container>
      </div>
    </>
  );
};

export default UsersPage;
